import { Avatar, AvatarFallback, AvatarImage } from '../avatar';

interface SidebarUserInfoProps {
    firstName: string;
    lastName: string;
    avatarUrl: string;
    isLoading?: boolean;
}

/**
 * Component to display user info (avatar and username) in the sidebar
 */
export const SideNavProfileWidget: React.FC<SidebarUserInfoProps> = ({
    firstName,
    lastName,
    avatarUrl,
    isLoading = false,
}) => {
    // Loading state skeleton
    if (isLoading) {
        return (
            <div className="flex items-center gap-x-3">
                <div className="h-10 w-10 animate-pulse rounded-full bg-gray-200"></div>
                <div className="h-4 w-24 animate-pulse rounded bg-gray-200"></div>
            </div>
        );
    }

    return (
        <div className="flex items-center gap-5">
            <div className="relative leading-4">
                <Avatar size="square56">
                    <AvatarImage src={avatarUrl} />
                    <AvatarFallback>
                        {firstName[0]}
                        {lastName[0]}
                    </AvatarFallback>
                </Avatar>
            </div>
            <span className="text-4 font-medium leading-5 text-gray-900 hover:text-gray-700">
                {`${firstName} ${lastName}`}
            </span>
        </div>
    );
};
